var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"col-2 mx-2 btn-select btn-w-date",class:{
     'selecting': _vm.isSelecting,
     'functional': _vm.isFunctionBtn
 },on:{"click":function($event){return _vm.btnClick(_vm.date, _vm.isDeparture)}}},[_c('span',{staticClass:"text"},[(_vm.date===_vm.getToday())?_c('span',{staticClass:"text-red"},[_vm._v("今日")]):_vm._e(),_vm._v(_vm._s(_vm.dateStr)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }